import React from 'react'
import TopBar from '../components/header/TopBar'
import HeaderOne from '../components/header/HeaderOne'
import RoomDetails2 from '../components/room-details/RoomDetailsTwo'
import SimilarRoom from '../components/room-details/SimilarRoom'
import FooterOne from '../components/footer/FooterOne'

function RoomDetailsTwo() {
  return (
    <div>
        <TopBar />
        <HeaderOne />
        <RoomDetails2 />
        <SimilarRoom />
        <FooterOne />
    </div>
  )
}

export default RoomDetailsTwo